import { Component, OnInit, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.css']
})
export class ImageViewComponent implements OnInit {

  @Input() title: string | null = null;
  @Input() imageUrl: SafeUrl | null = null;

  constructor(protected dialogRef: NbDialogRef<ImageViewComponent>, protected translate: TranslateService) { }

  ngOnInit(): void {
    console.log(this.imageUrl);
  }

  close() {
    this.dialogRef.close();
  }

}
